// extracted by mini-css-extract-plugin
export default {"card":"ReportCard_card__Xnwh8","innerCard":"ReportCard_innerCard__bll92","btn":"ReportCard_btn__ApjIS","bordered":"ReportCard_bordered__xboRy"};